import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { VisitsLogging, VisitParams } from "@/types";
import { fetchCurrentSessionInformation, saveVisitInfo } from "./thunk";

export interface VisitsLoggingState {
  sessionInfo: Partial<VisitsLogging>;
  pageData: Partial<VisitParams>;
  error: string | null;
  status: "idle" | "fetching" | "saving";
}

const initialState: VisitsLoggingState = {
  sessionInfo: {},
  pageData: {},
  error: null,
  status: "idle"
};

export const visitsLoggingSlice = createSlice({
  name: "visitsLogging",
  initialState,
  reducers: {
    setPageData: (state, action) => {
      state.pageData = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => ({
        ...state,
        ...action.payload[visitsLoggingSlice.name]
      }))
      .addCase(fetchCurrentSessionInformation.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchCurrentSessionInformation.fulfilled, (state, action) => {
        state.status = "idle";
        state.sessionInfo = action.payload;
      })
      .addCase(fetchCurrentSessionInformation.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      })
      .addCase(saveVisitInfo.pending, (state) => {
        state.status = "saving";
      })
      .addCase(saveVisitInfo.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(saveVisitInfo.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      });
  }
});

export const { setPageData } = visitsLoggingSlice.actions;
